export const ETR_WeeklySchema = [
  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,

    columns: [
      {
        title: "Test Description",
        colSpan: 7,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "testDescription",
        dataClassName: "text-left pd-left-10px d-block",
        isTitleOnly: true,
      },
      {
        title: "Condition",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        isTitleOnly: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        dataClassName: "text-left pd-left-10px d-block",
        isTitleOnly: true,
      },
    ],
  },

  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Power Off Light Weekly",
        colSpan: 7,
        unBold: true,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "testDescription",
      },
      {
        title: "Condition",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "cond1",
        isValueOnly: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        dataClassName: "text-left pd-left-10px d-block",
        accessor: "com",
        isValueOnly: true,
      },
    ],
  },

  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Light Units -- Physical Condition Weekly",
        colSpan: 7,
        unBold: true,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "testDescription",
      },
      {
        title: "Condition",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "cond2",
        isValueOnly: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        dataClassName: "text-left pd-left-10px d-block",
        accessor: "com6",
        isValueOnly: true,
      },
    ],
  },

  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Light Unit Alignment Weekly",
        colSpan: 7,
        unBold: true,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "testDescription",
      },
      {
        title: "Condition",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "cond3",
        isValueOnly: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        dataClassName: "text-left pd-left-10px d-block",
        accessor: "com10",
        isValueOnly: true,
      },
    ],
  },

  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Bell Operation Weekly",
        colSpan: 7,
        unBold: true,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "testDescription",
      },
      {
        title: "Condition",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "cond4",
        isValueOnly: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        dataClassName: "text-left pd-left-10px d-block",
        accessor: "com14",
        isValueOnly: true,
      },
    ],
  },

  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Light Unit Operation Weekly",
        colSpan: 7,
        unBold: true,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "testDescription",
      },
      {
        title: "Condition",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "cond5",
        isValueOnly: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        dataClassName: "text-left pd-left-10px d-block",
        accessor: "com18",
        isValueOnly: true,
      },
    ],
  },

  {
    heights: {
      header1: "auto",
      header2: "auto",
    },
    classes: { header1: "" },
    inlineBodyData: true,
    columns: [
      {
        title: "Gate Operation Weekly",
        colSpan: 7,
        unBold: true,
        rowSpan: 1,
        isTitleOnly: true,
        className: "tbl-text-normal",
        accessor: "testDescription",
      },
      {
        title: "Condition",
        colSpan: 3,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "cond6",
        isValueOnly: true,
      },
      {
        title: "Comments",
        colSpan: 10,
        rowSpan: 1,
        className: "tbl-text-normal",
        dataClassName: "text-left pd-left-10px d-block",
        accessor: "com22",
        isValueOnly: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/ETR/WeeklyReport/WeeklyReportSchema.js